import React from "react";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import VideoPlayer from "../../shared/video-player";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiVideoStart, pdiVideoWatch } from "../../../constants/tracking-constants/pre-delivery-inspection";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import styles from "./styles.css";
import { BodyText } from "@cars24/turbo-web/lib/body-text";

const PreDeliveryInspectionServices = ({
    details
}) => {

    const {
        subTitle: videoDescription = "",
        title: videoTitle = "",
        sectionData = []
    } = details || {};

    const {value: videoUrl = ""} = sectionData?.[0]?.videoUrl || {};
    const {url: thumbnailUrl = ""} = sectionData?.[0]?.videoThumnail?.value || {};

    const { tokens } = useTokens();

    const onProgress = async (played) => {
        const progress = Number(played.toFixed(NUMBER.TWO)) * NUMBER.HUNDRED;
        if ([NUMBER.TEN,
            NUMBER.TWENTY_FIVE,
            NUMBER.FIFTY,
            NUMBER.SEVENTY_FIVE,
            NUMBER.NINETY,
            NUMBER.HUNDRED].includes(progress)) {
            await yieldToMain();
            sendCustomGaEvents({
                ...pdiVideoWatch,
                eventLabel: progress
            });
        }
    };

    const handleStart = async () => {
        await yieldToMain();
        sendCustomGaEvents(pdiVideoStart);
    };

    if (!videoUrl) {
        return null;
    }

    return (
        <div styleName={"styles.servicesWrapper"}>
            <Heading level={2} color={tokens.text_default_text_primary}>{videoTitle}</Heading>
            <BodyText
                level={3}
                color={tokens.text_default_text_secondary}
                fontWeight="medium"
            >
                {videoDescription}
            </BodyText>
            <VideoPlayer
                autoPlay={true}
                url={videoUrl}
                controls={true}
                playing
                width="100%"
                height="100%"
                progressInterval={1000}
                playsinline={true}
                light={<img styleName={"styles.thumbnailContainer"} src={thumbnailUrl} height="100%" width="100%" alt="thumbnail" />}
                playIcon={<React.Fragment />}
                onProgress={({ played }) => onProgress(played)}
                onStart={() => handleStart()}
            />
        </div>
    );
};

PreDeliveryInspectionServices.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionServices;
